import { useEffect, useState } from 'react';
import { FormControl, FormLabel, Text, VStack } from '@chakra-ui/react';

import StrongModal from '../common/StrongModal';
import StrongInput from '../common/StrongInput';
import StrongImageDragDrop from '../common/StrongImageDragDrop';
import StrongTextarea from '../common/StrongTextarea';
import StrongSelect from '../common/StrongSelect';
interface EditResourceModalProps {
  selectedResource?: Resource;
  isOpen: boolean;
  onClose: () => void;
  programstitle: ProgramTitle[];
  onSubmit: (
    title: string,
    description: string,
    thumbnail: File | null,
    resourceFile: File | null,
    programs: string[],
  ) => void;
}

const EditResourceModal = ({
  selectedResource,
  isOpen,
  onClose,
  onSubmit,
  programstitle,
}: EditResourceModalProps) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);
  const [resourceFile, setResourceFile] = useState<File | null>(null);
  const [selectedprograms, setSelectedPrograms] =             
    useState<string[]>([]);  
  
  useEffect(() => {
    setTitle(selectedResource?.title || '');
    setDescription(selectedResource?.description || '');
    setThumbnail(null);
    setResourceFile(null);
    setSelectedPrograms(selectedResource?.programs || []);
  }, [selectedResource]);

  return (
    <StrongModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit(title, description, thumbnail, resourceFile, selectedprograms)}
      title={selectedResource ? 'Edit Resource' : 'Create Resource'}
      isSubmitDisabled={!title || (!selectedResource && !resourceFile)}
      body={
        <VStack spacing={4} align='stretch'>
          <FormControl>
            <FormLabel color='gray.600'>Title</FormLabel>
            <StrongInput
              placeholder='Enter title'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Description</FormLabel>
            <StrongTextarea
              placeholder='Enter description'
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Thumbnail</FormLabel>
            <StrongImageDragDrop
              onFileSelect={setThumbnail}
              defaultImageUrl={selectedResource?.thumbnail}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Resource File (PDF)</FormLabel>
            <StrongInput
              type='file'
              accept='.pdf,application/pdf'
              bg='white'
              p={1}
              onChange={(e) => {
                const file = e.target.files?.[0] ?? null;
                setResourceFile(file);
              }}
            />
            {selectedResource?.fileName && !resourceFile && (
              <Text mt={2} fontSize='sm' color='gray.500'>
                Current file: {selectedResource.fileName}
              </Text>
            )}
            {resourceFile && (
              <Text mt={2} fontSize='sm' color='gray.500'>
                Selected file: {resourceFile.name}
              </Text>
            )}
          </FormControl>

          <FormControl>
          <FormLabel color='gray.600'>Programs (optional)</FormLabel>                
          <StrongSelect                                             
            options={programstitle?.map(({ title, _id }) => ({label: title, value: _id })) || []}                         
            value={selectedprograms.map((value) => {
              const prog = programstitle?.find((p) => p._id ===     value);                                                     
              if (!prog) return null;                               
              return { label: prog.title, value: prog._id };        
            }).filter((o): o is { label: string; value: string } => 
        o !== null)}    
            onSelectChange={setSelectedPrograms}                    
          />
          </FormControl> 
        </VStack>
      }
    />
  );
};

export default EditResourceModal;
